import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  title: string;
  body: string;
  show: boolean;
}

const initialState: ModalState = {
  title: "",
  body: "",
  show: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<Partial<ModalState>>) => {
      return { ...state, ...action.payload };
    },
    closeModal: (state) => {
      state.show = false;
      state.title = "";
      state.body = "";
    },
  },
});

export const { setModal, closeModal } = modalSlice.actions;
export const modalReducer = modalSlice.reducer;
